'use client';

import { useState } from 'react';

interface ColorSwatchProps {
  color: {
    name: string;
    hex: string;
    rgb: string;
    textWhite: boolean;
  };
  copiedLabel: string;
  clickToCopyLabel: string;
}

export function ColorSwatch({ color, copiedLabel, clickToCopyLabel }: ColorSwatchProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(color.hex);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = color.hex;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="group rounded-2xl border border-slate-200 bg-white overflow-hidden text-left transition-all hover:shadow-md"
    >
      <div
        className="h-24 w-full"
        style={{ backgroundColor: color.hex }}
      />
      <div className="p-4">
        <p className="font-semibold text-slate-900">{color.name}</p>
        <p className="text-sm text-slate-600 font-mono">{color.hex}</p>
        <p className="text-sm text-slate-500">RGB: {color.rgb}</p>
        <p className="mt-2 text-xs text-slate-400 group-hover:text-brand-600 transition-colors">
          {copied ? copiedLabel : clickToCopyLabel}
        </p>
      </div>
    </button>
  );
}
